/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$:
    GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponseData;

  constructor(
    err:
      GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse";
  }
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse(
        v,
      );
    });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse
  > = z.instanceof(
    GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdErrorResponse$Outbound;
}
